import gql from 'graphql-tag';
import {globalInlineAlertFragments} from '@homeaway/react-global-messaging';
import {PriceDetailsWrapperFragment} from '../PriceDetailsWrapper/PriceDetailsWrapperFragment';

export const ConversationQuery = gql`
    query conversationQuery ($conversationId: String!) {
        conversation(
            conversationId: $conversationId
        ) {
            listing {
                address {
                    city
                }
                contact {
                    memberSince
                    ownerProfilePhoto
                    name
                }
                detailPageUrl
                geoCode {
                    exact
                    latitude
                    longitude
                }
                geography {
                    description
                }
                images {
                    c5_uri
                    uri
                }
                integratedPropertyManager
                ipmGuaranteedPricingActive
                listingId
                listingNumber
                ownerManaged
                responsiveness {
                    responseTimeString
                }
                unitApiUrl
            }
            priceDetails {
                ${PriceDetailsWrapperFragment}
            }
            tripSummary {
                arrivalDate
                departureDate
                reservationStatus
                conversationLifecycleState
            }
        }
        helpUrl
        getTravelerStay(conversationId: $conversationId) {
            booking {
                globalMessages {
                    ...GlobalInlineAlertGlobalMessages
                }
                guests {
                    adults
                    children
                }
                isPrimaryGuest
                listing {
                    address{
                        city
                    }
                    contact {
                        memberSince
                        ownerProfilePhoto
                        name
                    }
                    detailPageUrl
                    geoCode {
                        exact
                        latitude
                        longitude
                    }
                    geography {
                        description
                    }
                    images {
                        c5_uri
                        uri
                    }
                    integratedPropertyManager
                    ipmGuaranteedPricingActive
                    listingId
                    listingNumber
                    ownerManaged
                    responsiveness {
                        responseTimeString
                    }
                    unitApiUrl
                }
                periodOfStay {
                    checkInDate
                    checkInTime
                    checkOutDate
                    checkOutTime
                }
                reservationReferenceNumber
                uuid
            }
            ctaDetails {
              tripPaymentsLink
            }
            invoiceDownloadSummaries {
                downloadLinkText
                downloadLinkUrl
                text
                title
            }
            phaseOfStay
            propertyAddress {
                city
                postalCode
                stateProvince
                street1
                street2
            }
            propertyContact {
                phoneNumbers {
                    travelerDisplayablePhoneNumber {
                        fullPhoneDigits
                        fullPhoneNumber
                        phoneNumber
                    }
                }
            }
            stayDisplayStatus {
                code
                description
            }
            travelerStayReview {
                reviewFormUrl
            }
            uiComponentDetail {
                arrivalBot
                gogInvitePopup
                refundStatusWidget
            }
        }
    }
    ${globalInlineAlertFragments.GlobalMessages}
`;
